import { isTimeControl, rankWith } from "@jsonforms/core";

export default rankWith(5, isTimeControl);
